import Vue from 'vue'
import Vuex from 'vuex'
import { module as auth, actionNames as authActions } from './auth/store'
import { module as projects, actionNames as projectActions } from './projects/store'
import { module as overview, actionNames as overviewActions } from './overview/store'
import { module as admin, actionNames as adminActions } from './admin/store'
import { module as profile, actionNames as profileActions } from './settings/store'
import { module as customLabels, actionNames as customLabelActions } from './custom-labels/store'
import { module as sentimentRules, actionNames as sentimentRulesActions } from './sentiment-rules/store'

Vue.use(Vuex)

export const actionNames = {
  ...authActions,
  ...projectActions,
  ...overviewActions,
  ...adminActions,
  ...profileActions,
  ...customLabelActions,
  ...sentimentRulesActions
}

export default new Vuex.Store({
  modules: {
    auth,
    projects,
    overview,
    admin,
    profile,
    customLabels,
    sentimentRules
  }
})
